// export the routes, which is an array of objects
import Home from "../components/Home.vue";
import AboutUs from "../components/AboutUs.vue";
import Vision from "../components/vision.vue";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import TargetCustomers from "../components/TargetCustomers";
import OurCustomers from "../components/OurCustomers";
import privacy from "../components/privacy";
import Disclaimer from "../components/disclaimer";
import PageNotFound from "../components/PageNotFound";
import PaymentSuccess from "../components/payments/PaymentSuccess";
import paymentInformation from "../components/payments/paymentInformation";
import termsandcondition from "../components/TermsandConditions.vue";
import tandcsales from "../components/tandcsales.vue";
import cookie from "../components/cookie.vue";
import convertCurrencyHelp from "../components/help/convertCurrencyHelp.vue";
import financialStamentInputsHelp from "../components/help/financialStamentInputsHelp.vue";
// import forgotPassword from '../components/passwords/forgotPassword.vue'

// lazy loading
/* const Stocks = resolve => {
    require.ensure(['../components/stocks/Stocks.vue'], () => {
        resolve(require('../components/stocks/Stocks.vue'));
    });
}
const Portfolio = resolve => {
    require.ensure(['../components/portfolio/Portfolio.vue'], () => {
        resolve(require('../components/portfolio/Portfolio.vue'));
    });
} */

const Login = resolve => {
  require.ensure(["../components/login/UserLogin.vue"], () => {
    resolve(require("../components/login/UserLogin.vue"));
  });
};
const LoginOTP = resolve => {
  require.ensure(["../components/login/UserLoginOTP.vue"], () => {
    resolve(require("../components/login/UserLoginOTP.vue"));
  });
};
const Register = resolve => {
  require.ensure(["../components/register/UserRegister.vue"], () => {
    resolve(require("../components/register/UserRegister.vue"));
  });
};
const forgotPassword = resolve => {
  require.ensure(["../components/passwords/forgotPassword.vue"], () => {
    resolve(require("../components/passwords/forgotPassword.vue"));
  });
};

const resetPassword = resolve => {
  require.ensure(["../components/passwords/resetPassword.vue"], () => {
    resolve(require("../components/passwords/resetPassword.vue"));
  });
};

const TransformationInput = resolve => {
  require.ensure(
    ["../components/transformation/TransformationInput.vue"],
    () => {
      resolve(require("../components/transformation/TransformationInput.vue"));
    }
  );
};

const BalanceSheetGrid = resolve => {
  require.ensure(["../components/transformation/BalanceSheetGrid.vue"], () => {
    resolve(require("../components/transformation/BalanceSheetGrid.vue"));
  });
};

const OutputOne = resolve => {
  require.ensure(["../components/transformation/OutputOne.vue"], () => {
    resolve(require("../components/transformation/OutputOne.vue"));
  });
};
const GeneratePDF = resolve => {
  require.ensure(["../components/shared/generatePDF.vue"], () => {
    resolve(require("../components/shared/generatePDF.vue"));
  });
};
const FinancialStatements = resolve => {
  require.ensure(
    ["../components/transformation/FinancialStatements.vue"],
    () => {
      resolve(require("../components/transformation/FinancialStatements.vue"));
    }
  );
};
const PaymentPlan = resolve => {
  require.ensure(["../components/payments/PaymentPlan.vue"], () => {
    resolve(require("../components/payments/PaymentPlan.vue"));
  });
};
const Checkout = resolve => {
  require.ensure(["../components/payments/Checkout.vue"], () => {
    resolve(require("../components/payments/Checkout.vue"));
  });
};
const Assesment = resolve => {
  require.ensure(["../components/assesment/Assesment.vue"], () => {
    resolve(require("../components/assesment/Assesment.vue"));
  });
};
const paidAssesmentBalanceSheet = resolve => {
  require.ensure(
    ["../components/assesment/paidAssesmentBalanceSheet.vue"],
    () => {
      resolve(require("../components/assesment/paidAssesmentBalanceSheet.vue"));
    }
  );
};
const getAssesments = resolve => {
  require.ensure(["../components/assesment/AssesmentsList.vue"], () => {
    resolve(require("../components/assesment/AssesmentsList.vue"));
  });
};
const FinancialStatmentsTranslationPlans = resolve => {
  require.ensure(["../components/payments/translationPaymentPlans.vue"], () => {
    resolve(require("../components/payments/translationPaymentPlans"));
  });
};
const customerProfile = resolve => {
  require.ensure(["../components/customerProfile/customerProfile.vue"], () => {
    resolve(require("../components/customerProfile/customerProfile.vue"));
  });
};
const manageSubscription = resolve => {
  require.ensure(["../components/payments/manageSubscription.vue"], () => {
    resolve(require("../components/payments/manageSubscription"));
  });
};
/* const Assets = resolve => {
    require.ensure(['../components/balance-sheet/BalanceSheetGridAssets.vue'], () => {
        resolve(require('../components/balance-sheet/BalanceSheetGridAssets.vue'))
    })
}
const Liabilities = resolve => {
    require.ensure(['../components/balance-sheet/BalanceSheetGridLiabilities.vue'], () => {
        resolve(require('../components/balance-sheet/BalanceSheetGridLiabilities.vue'));
    });
}
const IncomeStatement = resolve => {
    require.ensure(['../components/balance-sheet/BalanceSheetGridIncomeStatement.vue'], () => {
        resolve(require('../components/balance-sheet/BalanceSheetGridIncomeStatement.vue'));
    });
}
const CashFlowStatement = resolve => {
    require.ensure(['../components/balance-sheet/BalanceSheetGridCashFlowStatement.vue'], () => {
        resolve(require('../components/balance-sheet/BalanceSheetGridCashFlowStatement.vue'));
    });
} */

export const routes = [
  {
    path: "/",
    component: Home,
    meta: { title: "FinTransform | Home", identify: "home" }
  },
  // { path: '/home', component: Home },
  {
    path: "/login",
    component: Login,
    meta: { title: "FinTransform | Login", identify: "login" }
  },
  {
    path: "/LoginOTP",
    component: LoginOTP,
    meta: { title: "FinTransform | Login", identify: "login" }
  },
  {
    path: "/register",
    component: Register,
    meta: { title: "FinTransform | Register", identify: "register" }
  },
  {
    path: "/forgotPassword",
    component: forgotPassword,
    meta: {
      title: "FinTransform | Forgot Password",
      identify: "forgotPassword"
    }
  },
  {
    path: "/resetPassword/:token/:email",
    component: resetPassword,
    meta: { title: "FinTransform | Reset Password", identify: "resetPassword" }
  },
  {
    path: "/about",
    component: AboutUs,
    meta: { title: "FinTransform | about" }
  },
  {
    path: "/vision",
    component: Vision,
    meta: { title: "FinTransform | Vision" }
  },
  {
    path: "/testimonials",
    component: Testimonials,
    meta: { title: "FinTransform | Testimonials" }
  },
  {
    path: "/faqs",
    component: FAQ,
    meta: { title: "FinTransform | FAQ", identify: "faqs" }
  },
  {
    path: "/privacy-policy",
    component: privacy,
    meta: { title: "FinTransform | Privacy Policy", identify: "privacy-policy" }
  },
  {
    path: "/disclaimer",
    component: Disclaimer,
    meta: { title: "FinTransform | Disclaimer", identify: "disclaimer" }
  },
  {
    path: "/target-customers",
    component: TargetCustomers,
    meta: { title: "FinTransform | Target Customers" }
  },
  {
    path: "/our-customers",
    component: OurCustomers,
    meta: { title: "FinTransform | Our Customers" }
  },
  {
    path: "/terms-and-conditions",
    component: termsandcondition,
    meta: {
      title: "FinTransform | terms-and-conditions",
      identify: "terms-and-conditions"
    }
  },
  {
    path: "/tandcsales",
    component: tandcsales,
    meta: { title: "FinTransform | tandcsales", identify: "tandcsales" }
  },
  {
    path: "/convertCurrencyHelp",
    component: convertCurrencyHelp,
    meta: {
      title: "FinTransform | convert Currency Help",
      identify: "convertCurrencyHelp"
    }
  },
  {
    path: "/financialStamentInputsHelp",
    component: financialStamentInputsHelp,
    meta: {
      title: "FinTransform | financial Stament Inputs Help",
      identify: "financialStamentInputsHelp"
    }
  },
  {
    path: "/cookie-policy",
    component: cookie,
    meta: { title: "FinTransform | cookie-policy", identify: "cookie-policy" }
  },
  {
    path: "/transformation-input/:type/:id?",
    component: TransformationInput,
    name: "TransformationInput",
    meta: {
      auth: true,
      title: "FinTransform | TransformationInput",
      identify: "transformation-input"
    }
  },
  {
    path: "/balancesheet-input/:id?",
    name: "InputTwo",
    component: BalanceSheetGrid,
    meta: {
      auth: true,
      title: "FinTransform | BalanceSheet",
      identify: "balancesheet-input"
    },
    props: true
  },
  {
    path: "/balancesheet-output/:id?",
    name: "OutputOne",
    component: OutputOne,
    meta: {
      auth: true,
      title: "FinTransform | Financial Statement",
      identify: "balancesheet-output"
    },
    props: true
  },
  {
    path: "/financial-statements",
    component: FinancialStatements,
    meta: {
      auth: true,
      title: "FinTransform | Financial Statements List",
      identify: "financial-statements"
    },
    props: true
  },
  {
    path: "/payment-plans",
    component: PaymentPlan,
    meta: {
      auth: true,
      title: "FinTransform | PaymentsPlans",
      identify: "payment-plans"
    },
    props: true
  },
  {
    path: "/checkout",
    component: Checkout,
    meta: {
      auth: true,
      title: "FinTransform | Checkout",
      identify: "checkout"
    },
    props: true
  },
  {
    path: "/payment-success",
    component: PaymentSuccess,
    meta: {
      auth: true,
      title: "FinTransform | payment-success",
      identify: "payment-success"
    },
    props: true
  },
  {
    path: "/payment-information",
    component: paymentInformation,
    meta: {
      auth: true,
      title: "FinTransform | payment-Information",
      identify: "payment-information"
    },
    props: true
  },
  // {
  //   path: '/assesment/:id',
  //   component: Assesment,
  //   meta: { auth: true, title: 'FinTransform | Assessment', identify: 'assessment' },
  //   props: true
  // },
  // {
  //   path: '/paidAssesmentBalanceSheet/:id?',
  //   component: paidAssesmentBalanceSheet,
  //   name: 'paidAssesmentBalanceSheet',
  //   meta: { auth: true, title: 'FinTransform | Assessment Balance Sheet', identify: 'paidAssesmentBalanceSheet' },
  //   props: true
  // },
  // {
  //   path: '/allAssesments',
  //   name: 'allAssesments',
  //   component: getAssesments,
  //   meta: { auth: true, title: 'FinTransform | Financial Assessment List', identify: 'allAssesments' },
  //   props: true
  // },
  { path: "/generatepdf", component: GeneratePDF, identify: "generatepdf" }, // test generate pdf component data
  {
    path: "/financialStatmentsTranslation-plans",
    component: FinancialStatmentsTranslationPlans,
    meta: {
      auth: true,
      title: "FinTransform | Payments Plans",
      identify: "financialStatmentsTranslation-plans"
    },
    props: true
  },
  {
    path: "/customerProfile",
    component: customerProfile,
    meta: {
      auth: true,
      title: "FinTransform | Customer Profile",
      identify: "customerProfile"
    },
    props: true
  },
  {
    path: "/manageSubscription",
    component: manageSubscription,
    meta: {
      auth: true,
      title: "FinTransform | Manage Subscription",
      identify: "manageSubscription"
    },
    props: true
  },
  {
    path: "/admin",
    beforeEnter() {
      location.href = "http://fintransformer.com:8081";
    }
  },
  {
    path: "*",
    component: PageNotFound,
    meta: { title: "FinTransform | 404", identify: "404" }
  }
];



// WEBPACK FOOTER //
// ./src/routes/routes.js